import React, { useEffect, useState } from 'react';
import { XIcon, CheckCircle } from 'lucide-react';
const purchases = [{
  name: 'Sarah M.',
  location: 'Austin, TX, USA'
}, {
  name: 'David L.',
  location: 'New York, NY, USA'
}, {
  name: 'Emily R.',
  location: 'Los Angeles, CA, USA'
}, {
  name: 'Michael C.',
  location: 'Chicago, IL, USA'
}, {
  name: 'Rachel K.',
  location: 'Miami, FL, USA'
}, {
  name: 'James T.',
  location: 'Denver, CO, USA'
}, {
  name: 'Megan B.',
  location: 'Seattle, WA, USA'
}, {
  name: 'Alex S.',
  location: 'Atlanta, GA, USA'
}];
export function UrgencyBanner() {
  const [visible, setVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(purchases[0]);
  useEffect(() => {
    const showPopup = () => {
      setCurrentPurchase(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      setTimeout(() => setVisible(false), 5000);
    };
    const interval = setInterval(showPopup, 15000);
    setTimeout(showPopup, 3000);
    return () => clearInterval(interval);
  }, []);
  return <>
      {visible && <div className="fixed bottom-3 left-3 right-3 sm:left-auto sm:right-4 z-50 animate-slide-in flex justify-center sm:justify-end pointer-events-none" data-id="element-181">
          <div className="bg-white border-2 border-brand-orange shadow-[0_4px_20px_rgba(255,102,0,0.3)] rounded-md p-2 pr-6 max-w-[280px] w-full relative overflow-hidden pointer-events-auto" data-id="element-182">
            <button onClick={() => setVisible(false)} className="absolute top-1 right-1 text-gray-400 hover:text-gray-600 transition-colors" data-id="element-183">
              <XIcon className="w-3.5 h-3.5" data-id="element-184" />
            </button>

            <div className="flex items-center gap-2.5" data-id="element-185">
              <div className="w-8 h-8 rounded-full bg-brand-pool/10 flex items-center justify-center shrink-0 border border-brand-pool/30" data-id="element-186">
                <CheckCircle className="w-4 h-4 text-brand-pool" data-id="element-187" />
              </div>
              <div className="leading-tight" data-id="element-188">
                <p className="font-bold text-brand-navy text-[13px]" data-id="element-189">
                  {currentPurchase.name}
                </p>
                <p className="text-[10px] text-gray-500 font-medium" data-id="element-190">
                  from {currentPurchase.location}
                </p>
                <p className="text-[11px] text-brand-orange font-bold mt-0.5" data-id="element-191">
                  purchased the digital book
                </p>
              </div>
            </div>
          </div>
        </div>}
    </>;
}